import { useNavigate } from 'react-router-dom'
import { useParams } from "react-router"
import { getId, getToken, usePermissions } from "../../user/User"
import { toast } from "react-toastify"
import { useEffect } from "react"
import { useTag } from "../../tag/Tag"
import axios from 'axios'

const TagDelete = () => {
    const navigate = useNavigate()

    let { id } = useParams()
    let { name } = useTag(id)

    const { permissions } = usePermissions(getId())
    useEffect(() => {
        if(permissions.tag === undefined) {
            return
        }
        if(!permissions.tag) {
            toast.error("You don't have permission to delete tags!")
            navigate("/")
        } else {
            if (confirm('Do you really want to delete this tag?')) {
                axios.delete(process.env.REACT_APP_API_URL + "/api/tags/" + id, { headers: {
                    "Authorization": "Bearer " + getToken()
                }}).then(_ => {
                    toast.success("Deleted tag " + name + " #" + id + ".")
                    navigate("/tag")
                }).catch(error => {
                    if (error.response) {
                        var statusCode = error.response.status
                        if(statusCode === 400) {
                            navigate("/tag")
                            toast.error("Invalid request.")
                            return
                        } else if(statusCode === 404) {
                            navigate("/tag")
                            toast.error("Unable to find tag #" + id + ".")
                            return
                        } else if(statusCode === 409) {
                            navigate("/tag")
                            toast.error("The tag #" + id + " is used in the client(s): " + error.response.data.clients.map(String).join(", "))
                            return
                        }
                    }
                    navigate("/tag")
                    toast.error("Internal error.")
                })
            } else {
                navigate("/tag")
            }
        }
    }, [permissions])

    return (
        <>
            <p>Deleting tag...</p>
        </>
    )
}

export default TagDelete